'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VIDEO_EVENTS = {
  ERROR: 'error',
  CAN_PLAY: 'can-play',
  STATE_CHANGED: 'state-changed',
  CHUNK_LOADED: 'chunk-loaded',
  METADATA_LOADED: 'metadata-loaded',
  CURRENT_TIME_UPDATED: 'current-time-updated',
  DURATION_UPDATED: 'duration-updated',
  LOAD_STARTED: 'load-started',
  LOADED_FIRST_CHUNK: 'loaded-first-chunk',
  SEEK_STARTED: 'seek-started',
  SEEK_ENDED: 'seek-ended',
  SET_CURRENT_TIME: 'set-current-time',
  VOLUME_STATUS_CHANGED: 'volume-status-changed',
  UPLOAD_STALLED: 'upload-stalled',
  UPLOAD_SUSPEND: 'upload-suspend'
};

exports.default = VIDEO_EVENTS;
//# sourceMappingURL=video.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/constants/events/video.js
// module id = 154
// module chunks = 1 2 3